const DEFAULT_SIGNUP_URL = 'https://app.adoriai.com/signup';
const SIGNUP_URL = process.env.REACT_APP_SIGNUP_URL || DEFAULT_SIGNUP_URL;

export function buildSignupUrl(baseSignupUrl = SIGNUP_URL) {
  if (typeof window === 'undefined') {
    return baseSignupUrl;
  }

  try {
    const sourceUrl = new URL(window.location.href);
    const aref = sourceUrl.searchParams.get('aref');

    if (!aref) {
      return baseSignupUrl;
    }

    const signupUrl = new URL(baseSignupUrl);
    signupUrl.searchParams.set('aref', aref);

    return signupUrl.toString();
  } catch {
    return baseSignupUrl;
  }
}
